/**
 * The animation director's store footprint (frontend.md §3.2).
 *
 * `busy` and `current` are diagnostics — the e2e suite reads them, and so does
 * the dev overlay. **No button reads them.** The one flag that is allowed to
 * gate input is `frozen`, which only the órdago freeze sets, and which the
 * director only sets on the clients of the pair being asked to answer.
 */

import type { StateCreator } from 'zustand';

import type { AnimSlice, Slices } from './types';

export const createAnimSlice: StateCreator<Slices, [], [], AnimSlice> = (set) => ({
  anim: {
    busy: false,
    current: null,
    frozen: false,
    skippable: false,
    setBusy: (busy, current) => {
      set((s) => ({ anim: { ...s.anim, busy, current } }));
    },
    setFrozen: (frozen) => {
      set((s) => (s.anim.frozen === frozen ? s : { anim: { ...s.anim, frozen } }));
    },
    setSkippable: (skippable) => {
      set((s) => (s.anim.skippable === skippable ? s : { anim: { ...s.anim, skippable } }));
    },
  },
});
